// Muestra, en la ficha de una oferta, las cuotas/promo y los logos de
// tarjetas aceptadas guardadas por PaymentInfoFields. No renderiza nada si
// la oferta no tiene ninguno de estos datos (son todos opcionales).
import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { T } from "../routes/Translate";
import { CARD_OPTIONS } from "./paymentCards";

const badgeSx = {
  fontSize: "0.85rem",
  backgroundColor: "#1f2a63",
  color: "#c7d2ff",
  padding: "6px 10px",
  borderRadius: "4px",
  display: "inline-block",
  fontWeight: 500,
};

const OfferPaymentBadges = ({ offer }) => {
  if (!offer) return null;
  const { installments, installmentsNoInterest, promo, acceptedCards } = offer;
  const cards = (acceptedCards || [])
    .map((id) => CARD_OPTIONS.find((c) => c.id === id))
    .filter(Boolean);

  if (!installments && !promo && cards.length === 0) return null;

  return (
    <Stack spacing={1} sx={{ mt: 2, mb: 2 }}>
      {(installments || promo) && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {installments && (
            <Typography sx={badgeSx}>
              <T>Hasta {installments} cuotas{installmentsNoInterest ? " sin interés" : ""}</T>
            </Typography>
          )}
          {promo && (
            <Typography sx={badgeSx}>
              {promo}
            </Typography>
          )}
        </Stack>
      )}
      {cards.length > 0 && (
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
            <T>Tarjetas que acepta</T>
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
            {cards.map((card) => (
              <Box
                key={card.id}
                component="img"
                src={card.img}
                alt={card.label}
                title={card.label}
                sx={{ height: 20, objectFit: "contain", backgroundColor: "#fff", borderRadius: "3px", p: "2px" }}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default OfferPaymentBadges;
